let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1K1Fj"), load("8hOn0"), load("xnqy2"), load("fJ8y4")]).then(() => parcelRequire('iyVZx'));